import type { Permission } from "../types/api";
import { useAuth } from "../services/auth";
import { StatusMessage } from "./StatusMessage";

type PermissionGateProps = {
  permission: Permission;
  children: React.ReactNode;
};

export function PermissionGate({ permission, children }: PermissionGateProps) {
  const { hasPermission } = useAuth();

  if (!hasPermission(permission)) {
    return (
      <StatusMessage tone="danger" title="Acesso restrito">
        Seu perfil nao possui permissao para acessar este modulo.
      </StatusMessage>
    );
  }

  return <>{children}</>;
}
